/**
 * Pure validation for the serial ("series") printer COM port.
 *
 * ESS-3866: a series printer must carry a non-empty port (e.g. "COM 2")
 * before the form can be saved — on both the add and the modify flow.
 * The save handler in PrinterConfig.tsx and the inline error indicator
 * (`inputPortSeries`) both go through this single predicate so the
 * requirement can't drift between the gate and the on-screen feedback.
 *
 * Lives in its own module (like computePrinterDuplicateIp) so the rule
 * can be unit-tested without pulling the full printer hook and its
 * React / store chain.
 *
 * IP and USB printers don't use this field, so callers only apply this
 * gate on the series branch.
 *
 * @param portSeries the currently selected COM port (form state)
 * @returns true when a non-empty port is set (whitespace-only is rejected)
 */
export function isSeriesPortFilled(
    portSeries: string | null | undefined
): boolean {
    return Boolean(portSeries?.trim());
}
